import { Typography } from "@mui/material";
import MDBox from "components/MDBox";
import { Line, LineChart, ResponsiveContainer } from "recharts";

function formatKpiValue(value) {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }
  return String(value ?? "");
}

function isPositiveDelta(delta) {
  if (typeof delta === "number") {
    return delta >= 0;
  }
  return String(delta ?? "").trim().startsWith("+");
}

export default function KpiRenderer({ label, value, unit, delta, subtext, trend }) {
  const formatted = formatKpiValue(value);
  const deltaPositive = isPositiveDelta(delta);

  return (
    <MDBox
      mt={1}
      sx={{
        borderRadius: "12px",
        border: "1px solid rgba(59,130,246,0.22)",
        bgcolor: "rgba(59,130,246,0.06)",
        p: 2,
      }}
    >
      {label ? (
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.75rem" }}>
          {label}
        </Typography>
      ) : null}
      <Typography
        component="p"
        sx={{
          m: 0,
          mt: 0.5,
          fontSize: "2rem",
          fontWeight: 700,
          lineHeight: 1.1,
          color: "primary.main",
        }}
      >
        {unit ? `${unit} ` : ""}
        {formatted}
      </Typography>
      {delta !== undefined ? (
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            display: "block",
            color: deltaPositive ? "success.main" : "error.main",
          }}
        >
          {String(delta)}
        </Typography>
      ) : null}
      {subtext ? (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.25, display: "block", fontSize: "0.7rem" }}>
          {subtext}
        </Typography>
      ) : null}
      {Array.isArray(trend) && trend.length > 1 ? (
        <MDBox sx={{ mt: 0.75, width: 180, height: 40 }}>
          <ResponsiveContainer>
            <LineChart data={trend.map((point, index) => ({ index, value: point }))}>
              <Line dataKey="value" stroke="#2563eb" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </MDBox>
      ) : null}
    </MDBox>
  );
}
